import RemoteWaiting from '@/views/RemoteWaiting/RemoteWaiting.vue';
import PublicRemoteWaiting from '@/views/RemoteWaiting/PublicRemoteWaiting.vue';
import { Route } from '../route.model';

// Private route for authenticated users
const waiting = new Route('/waiting', 'waiting', RemoteWaiting, {
  requiresAuth: true,
  requiresBusiness: true,
  navbar: {
    name: 'Waiting',
  },
});

const publicWaiting = new Route(
  '/public-waiting',
  'public-waiting',
  PublicRemoteWaiting,
  {
    requiresAuth: false,
    requiresBusiness: false,
    navbar: {
      name: 'Public Waiting',
    },
  },
);

export { waiting, publicWaiting };
export default waiting;
